export const APP_NAME = 'tradeIn';
